import { c as _c } from "react/compiler-runtime";
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { PaymentGatewaysLoco } from 'modules/profile/payment-gateways/constants/payment-gateways-loco';
import { PaymentGatewaysEnum } from 'modules/profile/payment-gateways/enums/payment-gateways';
import { CashOnDelivery } from 'modules/profile/payment-gateways/integrations/cash-on-delivery';
import { Flutterwave } from 'modules/profile/payment-gateways/integrations/flutterwave';
import { Gocardless } from 'modules/profile/payment-gateways/integrations/gocardless';
import { Mercadopago } from 'modules/profile/payment-gateways/integrations/mercadopago';
import { Mollie } from 'modules/profile/payment-gateways/integrations/mollie';
import { PaypalRest } from 'modules/profile/payment-gateways/integrations/paypal-rest';
import { usePaypalIntegrationType } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks/use-paypal-integration-type';
import { PaypalSoap } from 'modules/profile/payment-gateways/integrations/paypal-soap';
import { Paystack } from 'modules/profile/payment-gateways/integrations/paystack';
import { Razorpay } from 'modules/profile/payment-gateways/integrations/razorpay';
import { SecureAndPay } from 'modules/profile/payment-gateways/integrations/secure-and-pay';
import { Stripe } from 'modules/profile/payment-gateways/integrations/stripe';
import { Xendit } from 'modules/profile/payment-gateways/integrations/xendit';
import { NextPage } from 'next';
import React, { useMemo, type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const PaymentGateways: NextPage = () => {
  const $ = _c(13);
  const {
    t
  } = useLocoTranslation();
  const getPaymentIntegration = _temp;
  const {
    shouldShowRest,
    shouldShowSoap
  } = usePaypalIntegrationType();
  let t0;
  bb0: {
    if (shouldShowRest && shouldShowSoap) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Object.values(PaymentGatewaysEnum);
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    if (shouldShowRest) {
      let t1;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Object.values(PaymentGatewaysEnum).filter(_temp2);
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      t0 = t1;
      break bb0;
    }
    if (shouldShowSoap) {
      let t1;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Object.values(PaymentGatewaysEnum).filter(_temp3);
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = Object.values(PaymentGatewaysEnum).filter(_temp4);
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    t0 = t1;
  }
  const paymentGateways = t0;
  let t1;
  if ($[4] !== t) {
    t1 = t(settingsMenuLocoKeys.payment_gateways);
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = [{
      caption: t1,
      isStatic: true
    }];
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== paymentGateways) {
    t3 = <div className="bg-background-secondary flex h-fit w-full justify-center overflow-x-hidden rounded-md lg:justify-start lg:px-8 lg:py-3"><div className="flex w-full flex-col justify-center [&>*]:flex-1">{paymentGateways.map((el, idx) => <React.Fragment key={el}><div className="flex w-full flex-col px-6 py-12 lg:px-0 lg:py-8">{getPaymentIntegration(el)}</div>{idx !== paymentGateways.length - 1 && <hr className="text-text-secondary/30" />}</React.Fragment>)}</div></div>;
    $[8] = paymentGateways;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <SettingsLayout titles={t2} needSave={false}>{t3}</SettingsLayout>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export const getServerSideProps = getBaseServerSideProps(PaymentGatewaysLoco, 'global.settings');
export default PaymentGateways;
function _temp(payment) {
  switch (payment) {
    case PaymentGatewaysEnum.CashOnDelivery:
      {
        return <CashOnDelivery />;
      }
    case PaymentGatewaysEnum.Flutterwave:
      {
        return <Flutterwave />;
      }
    case PaymentGatewaysEnum.Gocardless:
      {
        return <Gocardless />;
      }
    case PaymentGatewaysEnum.MercadoPago:
      {
        return <Mercadopago />;
      }
    case PaymentGatewaysEnum.Mollie:
      {
        return <Mollie />;
      }
    case PaymentGatewaysEnum.PaypalRest:
      {
        return <PaypalRest />;
      }
    case PaymentGatewaysEnum.PaypalSoap:
      {
        return <PaypalSoap />;
      }
    case PaymentGatewaysEnum.Paystack:
      {
        return <Paystack />;
      }
    case PaymentGatewaysEnum.Razorpay:
      {
        return <Razorpay />;
      }
    case PaymentGatewaysEnum.SecureAndPay:
      {
        return <SecureAndPay />;
      }
    case PaymentGatewaysEnum.Stripe:
      {
        return <Stripe />;
      }
    case PaymentGatewaysEnum.Xendit:
      {
        return <Xendit />;
      }
  }
}
function _temp2(pg) {
  return pg !== PaymentGatewaysEnum.PaypalSoap;
}
function _temp3(pg_0) {
  return pg_0 !== PaymentGatewaysEnum.PaypalRest;
}
function _temp4(pg_1) {
  return pg_1 !== PaymentGatewaysEnum.PaypalRest && pg_1 !== PaymentGatewaysEnum.PaypalSoap;
}